import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { Flex, xcss } from '@atlaskit/primitives';
import Avatar from '@atlaskit/avatar';
import { messages } from '../../messages';
var negativeMarginStyles = xcss({
  margin: 'space.negative.025'
});
var CONTEXT_PATH = '/wiki';
export var GenericIconRenderer = function GenericIconRenderer(_ref) {
  var iconUrl = _ref.iconUrl,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'square' : _ref$appearance;
  return /*#__PURE__*/React.createElement(Flex, {
    xcss: negativeMarginStyles
  }, /*#__PURE__*/React.createElement(Avatar, {
    size: size,
    borderColor: "transparent",
    src: iconUrl,
    appearance: appearance,
    testId: "result-avatar"
  }));
};
export var quickFindRecentSpaceResultMapper = function quickFindRecentSpaceResultMapper(item) {
  var _item$links, _item$icon;
  return {
    id: (item === null || item === void 0 ? void 0 : item.id) || '',
    title: (item === null || item === void 0 ? void 0 : item.name) || '',
    meta: /*#__PURE__*/React.createElement(FormattedMessage, messages.quick_find_confluence_space),
    additionalMeta: /*#__PURE__*/React.createElement(FormattedMessage, messages.quick_find_recent_spaces_additional_meta),
    url: "".concat(CONTEXT_PATH).concat((item === null || item === void 0 || (_item$links = item.links) === null || _item$links === void 0 ? void 0 : _item$links.webui) || ''),
    containerId: (item === null || item === void 0 ? void 0 : item.id) || undefined,
    icon: GenericIconRenderer({
      iconUrl: "".concat(CONTEXT_PATH).concat((item === null || item === void 0 || (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.path) || ''),
      size: 'small'
    }),
    isRecentResult: true,
    type: 'confluence space'
  };
};